import { Api } from "@/core/api.js";
const api = new Api();
import Vue from "vue";
import router from "@/router";

// initial state
const state = {
  list: {},
  club_budgets: {},
  team_budgets: {},
  person_budgets: {},
  unpayed: {},
  importation: {},
  objectives: {},
  payments: {},
  paymentsCard: {},
  services: {},
  discounts: {},
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var finances = [];
    for (var i in state.list) {
      if (state.list[i].is_visible) finances.push(state.list[i]);
    }
    finances.sort(function(x, y) {
      // true values first
      //return (x.status === y.status)? 0 : x.status? -1 : 1;
      // false values first
      return x.status === y.status ? 0 : x.status ? 1 : -1;
    });
    return finances;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListNoFiltered: (state, getters, rootState) => type => {
    var aFinances = [];
    for (var i in state.list) {
      aFinances.push(state.list[i]);
    }
    return aFinances;
  },
  getTransactionTypes: (state, getters, rootState) => type => {
    var TransactionTypes = [
      { id: 1, name: "Transfer" },
      { id: 0, name: "TPV" }
    ];

    return TransactionTypes;
  },
  getTransactionStates: (state, getters, rootState) => type => {
    var TransactionTypes = [
      { id: 0, name: "finances.import.slopes" },
      { id: 1, name: "finances.import.assigneds" }
    ];

    return TransactionTypes;
  },
  getObjectives: (state, getters, rootState) => type => {
    return state.objectives;
    /*var finances = [];
    for( var i in state.list ){
        if( state.list[ i ].is_visible ) aClubs.push( state.list[ i ] );
    }
    return aClubs;*/
  },
  getPayments: (state, getters, rootState) => type => {
    return state.payments;
  },
  getPaymentsCard: (state, getters, rootState) => type => {
    return state.paymentsCard;
  },
  getImportationList: (state, getters, rootState) => type => {
    return state.importation;
  },
  get_transaction_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") return state.list[id];
    return false;
  },
  getUnpayed: (state, getters, rootState) => type => {
    return state.unpayed;
    /*var finances = [];
    for( var i in state.list ){
        if( state.list[ i ].is_visible ) aClubs.push( state.list[ i ] );
    }
    return aClubs;*/
  },
  getBudgetUnpayedById: (state, getters, rootState) => id => {
    if (typeof state.unpayed[id] !== "undefined") return state.unpayed[id];
    return false;
  },

  get_club_budget_by_id: (state, getters, rootState) => id => {
    if (typeof state.club_budgets[id] !== "undefined")
      return state.club_budgets[id];
    return false;
  },
  get_team_budget_by_id: (state, getters, rootState) => id => {
    if (typeof state.team_budgets[id] !== "undefined")
      return state.team_budgets[id];
    return false;
  },
  get_person_budget_by_id: (state, getters, rootState) => id => {
    if (typeof state.person_budgets[id] !== "undefined")
      return state.person_budgets[id];
    return false;
  },

  get_services: (state, getters, rootState) => id => {
    var oList = {};
    for (var k in state.services) {
      var service = state.services[k];
      if (typeof id === "undefined" || id == service.type) {
        oList[k] = service;
      }
    }
    return oList;
  },

  get_service_by_id: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.services[id];
    return false;
  },

  get_discounts: (state, getters, rootState) => id => {
    var oList = {};
    for (var k in state.discounts) {
      var discount = state.discounts[k];
      if (typeof id === "undefined" || id == discount.type) {
        oList[k] = discount;
      }
    }
    return oList;
  },

  get_discount_by_id: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.discounts[id];
    return false;
  }
};

// actions
const actions = {
  loadList({ commit, state }, params) {
    var path = "";
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;

    switch (params.submenu) {
      case "payments":
        path = "finances/payments/event/" + params.event;
        break;
      case "prices":
        page_options.num_items = -1;
        path = "finances/services/" + params.event;
        break;
      case "discounts":
        page_options.num_items = -1;
        path = "finances/discount/" + params.event;
        break;
      default:
        path = "finances/transactions";
    }

    var filters = params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = ["prices", "discounts"].includes(params.submenu)
          ? response.data
          : response.data.data;
        for (var i in data) {
          data[i].is_visible = true;
        }
        commit("setList", {
          data: data,
          total: ["prices", "discounts"].includes(params.submenu)
            ? Object.keys(response.data).length
            : response.data.total
        });
        return commit("setPagination", page_options);
      } else {
        commit("setList", []);
        return commit("setPagination", page_options);
      }
    });
  },
  loadListUnpayed({ commit, rootState }, params) {
    var path =
      "finances/budget/unpayed/" +
      rootState.events.current_event.id +
      "/" +
      (rootState.events.current_event.is_campus ? 3 : 2);
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        return commit("setListUnpayed", data);
      }
    });
  },

  load_club_by_id({ commit, rootState }, params) {
    var iEventID = rootState.events.current_event.id;
    var iType = 1;
    var iEntityID = params.id;

    var path = `finances/budget/${iEventID}/${iType}/${iEntityID}`;

    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.id = params.id;
        return commit("addClub", data);
      }
    });
  },
  load_team_by_id({ commit, rootState }, params) {
    var iEventID = rootState.events.current_event.id;
    var iType = rootState.events.current_event.is_campus ? 3 : 2;
    var iEntityID = params.id;

    var path = `finances/budget/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.is_visible = true;
        data.id = params.id;

        return commit("addTeam", data);
      }
    });
  },
  load_person_by_id({ commit, rootState }, params) {
    var iEventID = rootState.events.current_event.id;
    var iType = rootState.events.current_event.is_campus ? 3 : 2;
    var iEntityID = params.id;

    var path = `finances/budget/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.is_visible = true;
        data.id = params.id;

        return commit("addPerson", data);
      }
    });
  },
  load_transaction({ commit }, id) {
    var path = `finances/transaction`;
    return api.post(path, { transaction_id: id }).then(function(response) {
      if (response.status) {
        var data = response.data;
        return commit("setList", data);
      }
    });
  },
  upload({ commit }, form) {
    var path = "finances/import/transactions";
    return api.import(path, form).then(function(response) {
      if (response.status && response.data.length > 0) {
        return commit("setImportationList", response.data);
      }
      return false;
    });
  },

  conciliate(context, payments) {
    var path = "finances/transactions/conciliate";
    return api.post(path, payments).then(function(response) {
      if (response.status) {
        return context.dispatch("loadList").then(function() {});
      }
    });
  },
  deleteTransaction(context, id) {
    var path = `finances/transactions/delete`;
    return api.post(path, { transaction_id: id }).then(function(response) {
      if (response.status) {
        return context.dispatch("loadList").then(function() {});
      }
    });
  },
  deletePayment(context, id) {
    var path = `finances/payment/${id}/delete`;
    return api.post(path, {}).then(function(response) {
      if (response.status) {
        return true;
      }
    });
  },
  unConciliate(context, id) {
    var path = "finances/transactions/unConciliate";
    return api.post(path, { transaction_id: id }).then(function(response) {
      if (response.status) {
        var route = router.app._route;
        if (
          route.name == "event_teams_card" ||
          route.name == "event_clubs_card"
        ) {
          let path =
            route.name == "event_clubs_card"
              ? "payments_club"
              : "payments_team_card";
          context.dispatch(path, route.params.id).then(function() {});
          var oParams = {
            id: route.params.id
          };
          path =
            route.name == "event_clubs_card"
              ? "load_club_by_id"
              : "load_team_by_id";
          return context.dispatch(path, oParams).then(function() {});
        } else {
          return context.dispatch("loadList").then(function() {});
        }
      }
      return false;
    });
  },
  confirmTransactions(context, Transactions) {
    var path = "finances/import/transactions/confirmed";
    return api.post(path, Transactions).then(function(response) {
      if (response.status) {
        return context.dispatch("loadList").then(function() {});
      }
    });
  },
  objective({ commit, rootState }, event_id = 1) {
    var iEventID = rootState.events.current_event.id;
    var path = `finances/objective/check/${iEventID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setObjective", response.data);
      }
    });
  },

  addPayment({ commit, rootState }, data) {
    var iEventID = rootState.events.current_event.id;
    var iType = rootState.events.current_event.is_campus ? 3 : 2;
    var iEntityID = data.team_id;

    var path = `finances/budget/payment/add/${iEventID}/${iType}/${iEntityID}`;
    return api.post(path, data).then(function(response) {
      if (response.status) {
        return true;
      }
      return false;
    });
  },
  payments_team_card({ commit, rootState }, budget_id) {
    var iEventID = rootState.events.current_event.id;
    var iType = rootState.events.current_event.is_campus ? 3 : 2;
    var iEntityID = budget_id;

    var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setPaymentsCard", response.data);
      }
      return commit("setPaymentsCard", []);
    });
  },
  payments_club_card({ commit, rootState }, budget_id) {
    var iEventID = rootState.events.current_event.id;
    var iType = 1;
    var iEntityID = budget_id;

    var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setPaymentsCard", response.data);
      }
      return commit("setPaymentsCard", []);
    });
  },
  payments_person_card({ commit, rootState }, budget_id) {
    var iEventID = rootState.events.current_event.id;
    var iType = rootState.events.current_event.is_campus ? 3 : 2;
    var iEntityID = budget_id;

    var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setPaymentsCard", response.data);
      }
      return commit("setPaymentsCard", []);
    });
  },
  payments_team({ commit }, budget_id) {
    var path = `finances/budget/${budget_id}/payments`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setPayments", response.data);
      }
      return commit("setPayments", []);
    });
  },
  payments_club({ commit, rootState }, club_id) {
    var iEventID = rootState.events.current_event.id;
    var iType = 1;
    var iEntityID = club_id;

    var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setPaymentsCard", response.data);
      }
      return commit("setPaymentsCard", []);
    });
  },
  paymentsByTransaction({ commit }, transaction_id) {
    var path = `finances/transaction/payments`;
    return api.post(path, { transaction_id }).then(function(response) {
      if (response.status) {
        return commit("setPayments", response.data);
      }
    });
  },
  loadServices({ commit }, event_id) {
    var path = `finances/services/${event_id}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setServices", response.data);
      }
    });
  },
  loadDiscounts({ commit }, event_id) {
    var path = `finances/discount/${event_id}`;
    return api.get(path).then(function(response) {
      if (response.status) {
        return commit("setDiscounts", response.data);
      }
    });
  },
  addService({ commit }, payload) {
    var path = `finances/billing/service/add/${payload.event_id}/${
      payload.entity
    }/${payload.entity_id}`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  removeBillingService({ commit }, payload) {
    var path = `finances/billing/service/remove/${payload.event_id}/${
      payload.entity
    }/${payload.entity_id}/${payload.billing_line_id}`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  addDiscount({ commit }, payload) {
    var path = `finances/discount/assign`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  removeDiscount({ commit }, payload) {
    var path = `finances/discount/unassign`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  updateServiceBilling({ commit }, payload) {
    var path = `finances/billing/service/update/${payload.event_id}/${
      payload.entity
    }/${payload.entity_id}`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  updateBudgetVisible({ commit }, payload) {
    var path = `finances/budget/visible/${payload.event_id}/${payload.entity}/${
      payload.entity_id
    }`;
    return api.post(path, payload).then(function(response) {
      return response.status;
    });
  },
  loadPaymentsEvent({ commit }, event) {
    return api.get(`finances/payments/event/${event}`).then(function(response) {
      if (response.status) {
        return commit("setPayments", response.data);
      }
    });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },
  setImportationList(state, data) {
    var result = {};
    data.forEach(transaction => {
      result[transaction.id] = transaction;
    });
    state.importation = result;
  },
  addClub(state, club) {
    var list = { ...state.club_budgets };
    list[club.id] = club;

    state.club_budgets = list;
  },
  addTeam(state, team) {
    var list = { ...state.team_budgets };
    list[team.id] = team;

    state.team_budgets = list;
  },
  addPerson(state, person) {
    var list = { ...state.person_budgets };
    list[person.id] = person;

    state.person_budgets = list;
  },
  setListUnpayed(state, data) {
    var unpayed = { ...state.unpayed };
    for (const key in data) {
      unpayed[key] = [];
      data[key].forEach(budget => {
        unpayed[key].push(budget);
      });
    }
    state.unpayed = unpayed;
  },
  setObjective(state, data) {
    var objectives = { ...state.objectives };
    data.forEach(objective => {
      objectives[objective.id] = objective;
    });
    state.objectives = objectives;
  },
  setPayments(state, data) {
    var payments = { ...state.payments };
    state.payments = data;
  },
  setPaymentsCard(state, data) {
    state.paymentsCard = data;
  },
  setServices(state, data) {
    var services = { ...state.services };
    state.services = data;
  },
  setDiscounts(state, data) {
    var discounts = { ...state.discounts };
    state.discounts = data;
  },
  applyFilters(state, filters) {
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
